import { useSetAtom } from "jotai";
import { useCallback, useState } from "react";

import {
	$deleteWorkspaceAvatar,
	$uploadWorkspaceAvatar,
} from "../../internal/workspaces/workspace-avatar.atom";
import type { Workspace } from "../../internal/workspaces/workspace.types";

export const useWorkspaceAvatar = (workspace: Workspace | undefined) => {
	const uploadAvatarAtom = useSetAtom($uploadWorkspaceAvatar);
	const deleteAvatarAtom = useSetAtom($deleteWorkspaceAvatar);
	const [isUploading, setIsUploading] = useState(false);
	const [isDeleting, setIsDeleting] = useState(false);

	const uploadAvatar = useCallback(
		async (file: File) => {
			if (!workspace) {
				return;
			}
			setIsUploading(true);
			try {
				const avatarUrl = await uploadAvatarAtom({ workspace, file });
				return avatarUrl;
			} finally {
				setIsUploading(false);
			}
		},
		[workspace, uploadAvatarAtom]
	);

	const deleteAvatar = useCallback(async () => {
		if (!workspace) {
			return false;
		}
		setIsDeleting(true);
		try {
			const success = await deleteAvatarAtom(workspace);
			return success;
		} finally {
			setIsDeleting(false);
		}
	}, [workspace, deleteAvatarAtom]);

	return {
		uploadAvatar,
		deleteAvatar,
		isUploading,
		isDeleting,
	};
};
